import { ALL_STORE_ID } from '@/constants/global';
export default {
    workerDeliveryFeeGroupItems: (state) => state.workerDeliveryFeeGroup.map((it) => ({
        ...it,
        text: it.name,
        value: it.id,
    })),
    /**
     * 공유 정보 조회
     * @param {*} state
     * @returns
     */
    getAgencyShareInfo: (state) => ({ hubId: orderHubId, storeId: orderStoreId, }) => {
        const { agencyShareInfoList } = state;
        return agencyShareInfoList
            .find(({ hubId: shareInfoHubId, storeId: shareInfoStoreId, }) => {
            // 상점 단위 공유 정보 조회
            if (orderStoreId === shareInfoStoreId) {
                return true;
            }
            // 허브 단위 공유 정보 조회 (허브의 모든 상점 공유 여부)
            if (orderHubId === shareInfoHubId
                && shareInfoStoreId === ALL_STORE_ID) {
                return true;
            }
            return false;
        });
    },
};
